import authService, { AUTHORITIES } from 'app/services/authService';

const criaPermissoesComuns = (nome) => ({
  visualizar: authService.hasAuthority(AUTHORITIES[`${nome}_VISUALIZAR`]),
  cadastrar: authService.hasAuthority(AUTHORITIES[`${nome}_CADASTRAR`]),
  editar: authService.hasAuthority(AUTHORITIES[`${nome}_EDITAR`]),
  excluir: authService.hasAuthority(AUTHORITIES[`${nome}_EXCLUIR`]),
});

export const permissaoUtils = {
  categoria: () => ({ ...criaPermissoesComuns('CATEGORIA') }),
  centrocusto: () => ({ ...criaPermissoesComuns('CENTRO_CUSTO') }),
  cliente: () => ({ ...criaPermissoesComuns('CLIENTE') }),
  compra: () => ({ ...criaPermissoesComuns('COMPRA') }),
  conta: () => ({ ...criaPermissoesComuns('CONTA') }),
  contaPagar: () => ({ ...criaPermissoesComuns('CONTAPAGAR') }),
  contaReceber: () => ({ ...criaPermissoesComuns('CONTARECEBER') }),
  contrato: () => ({ ...criaPermissoesComuns('CONTRATO') }),
  estoque: () => ({ ...criaPermissoesComuns('ESTOQUE') }),
  fornecedor: () => ({ ...criaPermissoesComuns('FORNECEDOR') }),
  grupoAcesso: () => ({ ...criaPermissoesComuns('GRUPOACESSO') }),
  imposto: () => ({ ...criaPermissoesComuns('IMPOSTO') }),
  periodoFechado: () => ({ ...criaPermissoesComuns('PERIODOFECHADO') }),
  parametro: () => ({ ...criaPermissoesComuns('PARAMETRO') }),
  produto: () => ({ ...criaPermissoesComuns('PRODUTO') }),
  servico: () => ({ ...criaPermissoesComuns('SERVICO') }),
  transportadora: () => ({ ...criaPermissoesComuns('TRANSPORTADORA') }),
  usuario: () => ({ ...criaPermissoesComuns('USUARIO') }),
  venda: () => ({ ...criaPermissoesComuns('VENDA') }),
  vendedor: () => ({ ...criaPermissoesComuns('VENDEDOR') }),
  ordemServico: () => ({ ...criaPermissoesComuns('ORDEMSERVICO') }),
  minhaEmpresa: () => ({ ...criaPermissoesComuns('MINHAEMPRESA') }),
  transferencia: () => ({ ...criaPermissoesComuns('TRANSFERENCIA') }),
  integracaoContabil: () => ({ ...criaPermissoesComuns('INTEGRACAO_CONTABIL') }),
  configurarReguaCobranca: () => ({ ...criaPermissoesComuns('CONFIGURAR_RC') }),
  acompanharReguaCobranca: () => ({ ...criaPermissoesComuns('ACOMPANHAR_RC') }),
  gestaoEnvio: () => ({ ...criaPermissoesComuns('GESTAO_ENVIO') }),
  dashboard: () => ({ ...criaPermissoesComuns('DASHBOARD') }),
  ConciliacaoBancaria: () => ({ ...criaPermissoesComuns('CONCILIACAO') }),
};
